export * from './datepicker.directive';

import {DatePicker} from './datepicker.directive';

export const DATE_PICKER_DIRECTIVES = [
    DatePicker
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/datepicker/index.ts